<template lang="html">
  <div
    :class="[`vs-tabs-${color}`,`vs-tabs-position-${position}`]"
    class="con-vs-tabs vs-tabs" >
    <div style="margin-bottom: 2px;" class="con-ul-tabs">
      <ul
        ref="ul"
        :class="[`ul-tabs-${alignment}`]"
        class="ul-tabs vs-tabs--ul" style="box-shadow: none;">
        <li
          v-for="(child,index) in tabs"
          ref="li"
          :class="{'activeChild':childActive == index}"
          :style="childActive == index ? styleTab : {}"
          class="vs-tabs--li"
          @mouseover="hover = true"
          @mouseout="hover = false">
          <button
            v-bind="child.attrs"
            :style="styleAlignIcon(child.icon)"
            class="flex vs-tabs--btn"
            type="button"
            @click="activeChild(index)"
            v-on="child.listeners">
            <vs-icon
              v-if="child.icon"
              :icon-pack="child.iconPack"
              :icon="child.icon"
              :color="color"
              class="vs-tabs--btn-icon"></vs-icon>
                <span v-if="child.label">{{ child.label }}</span>
<!--                <span  v-if="child.chip"-->
<!--                       :style="{'background':`${child.chip_color}`}"-->
<!--                        style="padding: 0 6px;-->
<!--                        text-align: center;-->
<!--                        border-radius: 10px;-->
<!--                        box-shadow: 0 0 0 1px #fff;min-width: 20px;-->
<!--                        height: 20px;-->
<!--                        color: #fff;-->
<!--                        font-weight: normal;-->
<!--                        font-size: 12px;-->
<!--                        line-height: 20px;-->
<!--                        white-space: nowrap;">-->
<!--                    {{ child.chip }}-->
<!--                </span>-->

          </button>

          <button
            v-if="child.tag"
            class="vs-tabs--btn-tag"
            @click="clickTag(child)"
          >
            <vs-icon
              :icon-pack="child.iconPack"
              :icon="child.tag"
              :color="child.tagColor"></vs-icon>
          </button>
        </li>
      </ul>
      <span
        :style="stylex"
        class="line-vs-tabs"/>
    </div>
    <div class="con-slot-tabs">
      <slot/>
    </div>
  </div>
</template>

<script>
import _color from "@/localNodeModules/vuesax/utils/color";
import vsIcon from '@/localNodeModules/vuesax/components/vsIcon/vsIcon'
export default {
    name:'VsTabs',
    components:{vsIcon},
    props:{
        value: {
            default: 0,
            type: [Number, String],
        },
        color:{
            default:'primary',
            type: String
        },
        tagColor:{
            default:'primary',
            type: String
        },
        alignment:{
            default:'left',
            type:String,
        },
        position:{
            default:'top',
            type:String
        },
        tabs:{
            type:Array,
        }
    },
    data:()=>({
        topx:'auto',
        heightx:2,
        hover:false,
        children:[],
        childActive:0,
        leftx:0,
        widthx:0,
        these:false,
    }),
    computed:{
        styleTab(){
            return {
                color: _color.getColor(this.color,1),
            }
        },
        stylex(){
            return {
                top: `${ this.topx }px`,
                left: `${ this.leftx }px`,
                width: `${ this.widthx }px`,
                height: `${ this.heightx }px`,
                transform: `scaleX(${ this.these?1.3:1 })`
            }
        }
    },
    watch: {
        value(index) {
            const activeIndex = this.parseIndex(index)
            this.activeChild(activeIndex)
        },
    },
    async mounted(){
        let activeIndex = this.parseIndex(this.value)
        // this.$nextTick(async () => {
        //
        // })
        if (this.$route.query.tabs_menu){
            activeIndex = await this.tabs.findIndex(item=>item.code==this.$route.query.tabs_menu)
        }
        this.childActive = await activeIndex
        await this.activeChild(activeIndex, true)
    },
    methods:{
        clickTag(child) {
            this.$emit('click-tag', child)
        },
        styleAlignIcon(icon){
            return icon ? 'display:flex;align-items:center' : ''
        },
        parseIndex(index) {
            let activeIndex = this.childActive
            if (index < 0) {
                activeIndex = 0
            } else if (index >= this.tabs.length) {
                activeIndex = this.tabs.length - 1;
            } else if (typeof this.tabs[index].disabled === 'undefined') {
                activeIndex = parseInt(index);
            }
            return activeIndex;
        },
        async activeChild(index, initialAnimation){
            initialAnimation = !!initialAnimation;
            const elem = this.$refs.li[index]
            if(this.childActive == index && !initialAnimation){
                this.these = true
                elem.classList.add('isActive')
                setTimeout(()=>{
                    elem.classList.remove('isActive')
                    this.these = false
                }, 200);
            }

            this.tabs.map((item,item_index)=>{
                if(item_index != index) {
                    item.active = false
                }
            })

            // if(this.childActive > index){
            //     this.tabs[index].invert = true
            //     this.tabs[this.childActive].invert = false
            // } else {
            //     this.tabs[this.childActive].invert = true
            //     this.tabs[index].invert = false
            // }

            this.tabs[index].active = true
            this.childActive = index
            this.$emit('input', this.childActive)

            if(this.position == 'left' || this.position == 'right'){
                this.tabs[index].vertical = true
            }

            this.changePositionLine(elem, initialAnimation)
            if (this.$route.query.tabs_menu!==this.tabs[index].code){
                let queries = { ...this.$route.query };
                queries['tabs_menu'] = this.tabs[index].code;
                this.$router.replace({ name: this.$route.name, query:queries })
            }
            this.$emit('updateData')

        },
        changePositionLine(elem, initialAnimation){
            if(this.position == 'left' || this.position == 'right'){
                this.topx = elem.offsetTop
                this.heightx = elem.offsetHeight
                this.widthx = 2
            } else {
                const update = () => {
                    this.leftx = elem.offsetLeft
                    this.widthx = elem.offsetWidth
                    this.topx = (elem.offsetHeight + (elem.getBoundingClientRect().top - this.$refs.ul.getBoundingClientRect().top))
                }
                if (!initialAnimation) {
                    update()
                } else {
                    setTimeout(update, 100)
                }
            }
        }
    }
}
</script>
